export interface UserProfile {
  userId: string;
  username: string;
  usernameSetupCompleted: boolean;
}

export interface ProfileUpdate {
  username?: string;
  completeUsernameSetup?: true;
}

export const USERNAME_PATTERN = /^[A-Za-z0-9_]{3,24}$/;
export const USERNAME_HELP = 'Use 3–24 letters, numbers, or underscores.';

export class InvalidProfileError extends Error {}

export function normalizeUsername(value: unknown): string {
  if (typeof value !== 'string' || !USERNAME_PATTERN.test(value.trim())) {
    throw new InvalidProfileError(USERNAME_HELP);
  }
  return value.trim();
}

export function parseProfileUpdate(value: unknown): ProfileUpdate {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    throw new InvalidProfileError('Choose a username or keep your generated username.');
  }
  const input = value as Record<string, unknown>;
  if (Object.keys(input).some((key) => key !== 'username' && key !== 'completeUsernameSetup')
    || ('completeUsernameSetup' in input && input.completeUsernameSetup !== true)
    || (!('username' in input) && input.completeUsernameSetup !== true)) {
    throw new InvalidProfileError('Invalid profile update.');
  }
  return {
    ...('username' in input ? { username: normalizeUsername(input.username) } : {}),
    ...(input.completeUsernameSetup === true ? { completeUsernameSetup: true as const } : {}),
  };
}
